// AWS React
import { 
    useEffect, 
    useState, 
} from 'react';
import { useHistory } from 'react-router-dom';

// Material-ui
import { 
    makeStyles, 
} from '@material-ui/core/styles';
import { 
    Container, 
    Box, 
    Grid, 
    Typography,
    IconButton, 
} from '@material-ui/core';

// Self Making Files
import { 
    URL_PARTS_SLASH, 
    URL_PATH_ESEDITOR, 
    FORMAT_STRING_YYYYMMDDHHMM,
    CAPTION_CORPORATION_NAME,
    DATA_CARD_CAPTION_DEADLINE, 
} from '../../Commons/Consts';
import { getStringFromDateForFormatString } from "../../Commons/CommonFunctions";
import { ArrowForwardIos } from "@material-ui/icons";
import { commonStyles } from '../../Commons/CommonStyles';

const localStyles = makeStyles(theme => ({
    entrysheetCard:{
        borderRadius: "10px",
        padding: "10px",
        marginBottom: "1px",
        backgroundColor: theme.palette.background.paper,
        border: "solid #AAAAAA 1px",
        cursor: "pointer",
    },
}));

export function EntrysheetDataCard({ eventData, corporations }){
    const localStyle = localStyles();
    const history = useHistory();
    const [corpName] = useState(corporations.items.find((corp) => {return corp.id === eventData.corporationsID}).corporationName);
    
    useEffect(() => {
        return;
    }, [])

    return (
        <Grid 
            container 
            spacing={0} 
            className={localStyle.entrysheetCard}
            onClick={() => {
                history.push(URL_PATH_ESEDITOR + URL_PARTS_SLASH + String(eventData.id));
            }}
        >
            <Grid item xs={11} spacing={0}>
                <Grid container spacing={0}>
                    <Grid item xs={7}>
                        <Typography variant="caption">{CAPTION_CORPORATION_NAME}</Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="caption">{DATA_CARD_CAPTION_DEADLINE}</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={0}>
                    <Grid item xs={7}>
                        <Container>
                            <Typography>{corpName}</Typography>
                        </Container>
                    </Grid>
                    <Grid item xs={5}>
                        <Container>
                            <Typography>{getStringFromDateForFormatString(new Date(eventData.deadlineDateTime), FORMAT_STRING_YYYYMMDDHHMM)}</Typography>
                        </Container>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={1} className={commonStyles.centerContents}>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                >
                    <ArrowForwardIos />
                </IconButton>
            </Grid>
            <Grid item xs={12}>
                <Box pt={2}></Box>
            </Grid>
        </Grid>
    )
}

